module.exports = __webpack_public_path__ + "static/media/profile_student_placeholder.cccf3d7d.png";